import useSWRImmutable from "swr";
import { Identity } from 'merchant-api/types';
import { getCheckoutState } from '../getCheckoutState/getCheckoutState';

interface IdentityQuestionsProps {
  isLoadingIdentityQuestions: boolean;
  isErrorIdentityQuestions: any;
  identityData?: Identity;
}

export function getIdentityQuestions(): IdentityQuestionsProps {
  const apiUrl = import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL']
  const { checkoutData, isLoadingCheckoutState, isErrorCheckoutState } = getCheckoutState();

  const { data, error, isLoading } = useSWRImmutable((checkoutData?.checkoutUuid ? `${ apiUrl }/v1/identity-verification/${ checkoutData.checkoutUuid }/iq`: null), {revalidateOnFocus: false});

  return {
    isLoadingIdentityQuestions: isLoading || isLoadingCheckoutState,
    isErrorIdentityQuestions: error || isErrorCheckoutState,
    identityData: data,
  }
}
